module.exports = __webpack_public_path__ + "static/img/empty.5db73532.png";